module.exports = __webpack_public_path__ + "static/media/icons_Bilan SSMP.768ae516.svg";